import { useQuery } from '@tanstack/react-query';
import { getMeTrend } from '../services/trend.service';

// The referee's own recent trend, for Home's Study-streak + Rule-accuracy sparklines. Same gating
// and staleness as useRefereeStatsQuery/useMasteryQuery — only clip-answering roles have a trend.
export function useTrendQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['referee-trend'],
    queryFn: getMeTrend,
    enabled,
    staleTime: 30_000,
  });
}
